// Existing public URLs retained when the WordPress site is replaced.
export const legacyRoutes = [{
  source: '/ai-seminar-landing-page',
  destination: '/ai-automation'
}, {
  source: '/ai-workshop-level-1-booking',
  destination: '/contact'
}, {
  source: '/ethics-integrity',
  destination: '/about#principles'
}, {
  source: '/sustainability',
  destination: '/about#principles'
}, {
  source: '/author/vkaralewich',
  destination: '/news'
}];
